import React, {useEffect, useState} from 'react';
import {IndividualsFormEdit} from "../../components/individuals/IndividualsFormEdit";
import {useSearchParams} from "react-router-dom";
import {useGetIndividualQuery} from "../../store/backend-api/backend.api";

export function EditIndividualsForm () {
    const [searchParams] = useSearchParams()
    const id = Number(searchParams.get("id"))
    const {data, isSuccess} = useGetIndividualQuery(id)
    const [key, setKey] = useState(0)

    useEffect(() => {
        setKey((prevState) => prevState + 1)
    }, [data])

    return (<div key={key}>
        {isSuccess && <IndividualsFormEdit data={data}/>}
    </div>)
}